import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { ProductsPage } from './_dashboard.catalog.products'

export const Route = createFileRoute('/_dashboard/catalog/products/$selectedItem')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: ProductsSelectedItemPage,
})

function ProductsSelectedItemPage() {
  const { selectedItem } = Route.useParams()
  return <ProductsPage selectedId={selectedItem} />
}
